import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Colors from "../../constants/Colors";

import menu from "./menu";
import MenuTab from "./MenuTab";
import { Route, Redirect } from "react-router-dom";
import Client from "../../Client";

import Team from "../Team";
import Recap from "../Recap";
import Actions from "../Actions";
import Settings from "../Settings";
import Stats from "../Stats";
import Polls from "../Polls";

import Logo from "../../resources/logo.png";

import { connect } from "react-redux";
import AdminMenu from "./AdminMenu";
import RandomCoffee from "../RandomCoffee";

const drawerWidth = 240;

const styles = theme => ({
  root: {
    backgroundColor: "#F4F6F9",
    display: "flex"
  },
  toolbar: {
    paddingRight: 24 // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  toolBarChevron: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  // logoContainer: {
  //   flex: 1,
  //   alignItems: "center",
  //   justifyContent: "flex-end"
  // },
  appBar: {
    backgroundColor: Colors.pureMain,
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  menuButtonHidden: {
    display: "none"
  },
  title: {
    flexGrow: 1
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9
    }
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: "100vh",
    overflow: "auto"
  },
  chartContainer: {
    marginLeft: -22
  },
  tableContainer: {
    height: 320
  },
  h5: {
    marginBottom: theme.spacing.unit * 2
  },
  logo: {
    width: "50%"
  }
});

class Dashboard extends React.Component {
  state = {
    open: true,
    selectedIndex: 0
  };

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  onClickMenu = selectedIndex => () => {
    this.setState({ selectedIndex });
  };

  displayRouteName = location => {
    if (location.indexOf("settings") > -1) {
      return "Paramètres";
    } else if (location.indexOf("actions") > -1) {
      return "Actions";
    } else if (location.indexOf("team") > -1) {
      return "Mon Équipe";
    } else if (location.indexOf("coffee") > -1) {
      return "Random Coffee";
    } else if (location.indexOf("polls") > -1) {
      return "Sondages";
    }
    return "Dashboard";
  };

  getRouteName = location => {
    if (location.indexOf("settings") > -1) {
      return "settings";
    } else if (location.indexOf("actions") > -1) {
      return "actions";
    } else if (location.indexOf("team") > -1) {
      return "team";
    } else if (location.indexOf("coffee") > -1) {
      return "coffee";
    } else if (location.indexOf("polls") > -1) {
      return "polls";
    }
    return "dashboard";
  };

  render() {
    const { classes, token } = this.props;

    if (!token) {
      return <Redirect to="/login" />;
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <AppBar
            position="absolute"
            className={classNames(
              classes.appBar,
              this.state.open && classes.appBarShift
            )}
          >
            <Toolbar
              disableGutters={!this.state.open}
              className={classes.toolbar}
            >
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(
                  classes.menuButton,
                  this.state.open && classes.menuButtonHidden
                )}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                className={classes.title}
              >
                {this.displayRouteName(this.props.location.pathname)}
              </Typography>
              {this.props.isAdmin && <AdminMenu />}
              <IconButton color="inherit">
                {/* <Badge badgeContent={4} color="secondary"> */}
                <NotificationsIcon />
                {/* </Badge> */}
              </IconButton>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !this.state.open && classes.drawerPaperClose
              )
            }}
            open={this.state.open}
          >
            <div className={classes.toolbarIcon}>
              {/* <div className={classes.logoContainer}> */}
              <img src={Logo} alt="Pulse Logo" className={classes.logo} />
              {/* </div> */}
              <IconButton
                onClick={this.handleDrawerClose}
                className={classes.toolBarChevron}
              >
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <Divider />
            <List>
              {menu.map((el, i) => {
                return (
                  <MenuTab
                    currentRoute={this.getRouteName(
                      this.props.location.pathname
                    )}
                    icon={el.icon}
                    route={el.route}
                    path={el.path}
                    hasAccess={
                      this.props.hasAccess ||
                      el.route === "team" ||
                      el.route === "settings" ||
                      el.route === "polls"
                    }
                    text={el.text}
                    key={i}
                  />
                );
              })}
            </List>
          </Drawer>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <div>
              <Route exact path="/team" component={Team} />
              <Route exact path="/polls" component={Polls} />
              <Route exact path="/settings" component={Settings} />
              <Route exact path="/stats" component={Stats} />
              {/* <Route exact path="/" component={Recap} /> */}
              <Route
                exact
                path="/"
                render={() =>
                  !this.props.hasAccess ? <Redirect to="/team" /> : <Recap />
                }
              />
              {this.props.hasAccess && (
                <div>
                  <Route exact path="/clients" component={Client} />
                  <Route exact path="/actions" component={Actions} />
                  <Route exact path="/coffee" component={RandomCoffee} />
                </div>
              )}
            </div>
          </main>
        </div>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { role } = state.auth;
  return {
    token: state.auth.accessToken,
    isAdmin: role === "admin",
    hasAccess: role !== "user"
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(Dashboard));
